import {clsx} from "clsx";
import React, {useState} from "react";
import {useSwipeable} from "react-swipeable";
import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {text} from "../../constants/text";

const AddressItem = ({item, index, handleDeleteAddress, addressAll, handlePrimary, handleUpdateAddress}) => {
  const [isSwipedOpen, setIsSwipedOpen] = useState(false);

  const handlers = useSwipeable({
    onSwipedLeft: () => setIsSwipedOpen(true),
    onSwipedRight: () => setIsSwipedOpen(false),
    trackMouse: true
  });
  const handleRemoveItem = (id) => {
    setIsSwipedOpen(false);
    handleDeleteAddress(id);
  };
  return (
    <div
      key={index}
      className={clsx("relative touch-pan-y bg-white rounded-xl md:rounded-none",
        index === addressAll?.items.length - 1 ? '' : 'border-b border-dashed border-[#D9D9D9]')}
    >
      <div
        {...handlers}
        className={clsx(
          'flex justify-between items-center py-4 w-full md:w-auto  px-4 md:px-[10px] transition-transform duration-300',
          item?.isPrimary ? 'bg-[#FFFCF3] rounded-t-xl md:rounded-none' : 'bg-white',
          isSwipedOpen && !item?.isPrimary ? 'translate-x-[-110px]' : 'translate-x-0',
          index === addressAll?.items.length - 1 ? 'rounded-b-xl' : 'border-b border-dashed border-[#D9D9D9]'
        )}
      >
        <div
          className='flex flex-col justify-center text-[#656565] w-full md:w-auto text-sm space-y-[10px]'>
          <div
            className='flex md:items-center justify-between md:justify-normal text-sm space-x-4 text-black'>
            <div className='text-black'>{item.name}</div>
            <div className='md:hidden' onClick={() => handleUpdateAddress(item)}>{text.EDIT}</div>
            {item?.isPrimary ? <div
              className='hidden md:flex items-center justify-center space-x-1 border border-[#FF5B21] rounded-xl px-3'>
              <div className='text-[12px] text-[#FF5B21]'>Mặc định</div>
            </div> : ''}
          </div>
          <div>{item.phoneNumber}</div>
          <div>
            <div>{`${item?.address}, ${item?.commune}, ${item?.district}, ${item?.province}`}</div>
            {item?.note && <div>{`Ghi chú: ${item?.note ?? ""}`}</div>}
          </div>
          {!item?.isPrimary ? <div
            onClick={() => handlePrimary(item?.id)}
            className='flex items-center space-x-1 border border-[#828282] rounded-2xl w-fit px-3 cursor-pointer'>
            <div className='text-[12px] text-black'>Thiết lập mặc định</div>
          </div> : ''}
          {item?.isPrimary ? <div
            className='md:hidden flex items-center space-x-1 border border-[#FF5B21] rounded-xl w-fit px-3 cursor-pointer'>
            <div className='text-[12px] text-[#FF5B21]'>Mặc định</div>
          </div> : ''}
        </div>
        <div
          className='hidden md:flex justify-center items-center text-sm cursor-pointer pr-4 space-x-1'>
          <div onClick={() => handleUpdateAddress(item)}>{text.EDIT}</div>
          {!item?.isPrimary ?
            <div onClick={() => handleDeleteAddress(item?.id)}>{`| ${text.delete}`}</div> : ''}
        </div>
        {/* Delete button revealed on swipe */}
        {!item?.isPrimary && <button
          onClick={() => handleRemoveItem(item?.id)}
          className={clsx(
            'absolute right-[-25%] top-1/2 -translate-y-1/2 rounded w-[90px] h-[110px] bg-[#F8C518] flex flex-col items-center justify-center md:hidden',
            'transition-opacity duration-200',
            isSwipedOpen ? 'opacity-100' : 'opacity-0'
          )}
        >
          <ImageBasic
            src={IMG.icon.trash}
            className='w-6 h-6'
            alt="Delete"
          />
          <div>
            {text.delete}
          </div>
        </button>}
      </div>
    </div>
  );
};
export default AddressItem;